'use strict';

function ServiceManagementGridDirective() {
  return {
    restrict: 'E',
    template: require('../templates/service-management-grid.html'),
    controller: 'ServiceManagementGridController',
    scope: {
      selectedFlights: '<'
    },
    link: function link(scope) {
      scope.$watch('selectedFlights', scope.onSelectFlights);
      scope.$on('collapsable-panel-trigger', scope.onPanel);
    }
  };
}
ServiceManagementGridDirective.$inject = [];
module.exports = ServiceManagementGridDirective;